var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _line, _line2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.5 19V33H27.5V28H32.5V19H18.5ZM25.5 28H20.5V26H25.5V28ZM30.5 24H20.5V22H30.5V24Z",
    fill: "#1565D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 19V28H27.5V33H18.5V19H32.5ZM32.5 17H18.5C17.4 17 16.5 17.9 16.5 19V33C16.5 34.1 17.4 35 18.5 35H28.5L34.5 29V19C34.5 17.9 33.6 17 32.5 17ZM25.5 28H20.5V26H25.5V28ZM30.5 24H20.5V22H30.5V24Z",
    fill: "#1565D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 38L50 -8.74228e-08L52 0L52 38C51.5 38.5 51.5 38.5 51.5 38.5C51.5 38.5 50.3905 38 50 38Z",
    fill: "#1565D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.641 38.3781L39.4493 51.1986C39.098 51.4952 38.4999 51.9999 38.4999 51.9999C38.4999 51.9999 37.6079 50.5577 37.5 50.0001L50.1917 36.9999L51.641 38.3781Z",
    fill: "#1565D8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.37115e-8,
    x2: 0.999998,
    y2: 52,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 1,
    y2: 1,
    stroke: "#1565D8",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 51L2 51",
    stroke: "#1565D8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTeam);
export default __webpack_public_path__ + "static/media/content-team.471aed33be178ae6e2af6bcd360a10ee.svg";
export { ForwardRef as ReactComponent };